// Procedures.tsx
import { FC, useCallback, useContext } from "react";

import { ProcedureContext } from "@/context/ProcedureContext";
import { Grid } from "@mui/material";

import { BreadCrumbsDesign } from "@/components/Application/BreadCrumbsDesign";
import { WrapperHeadingLeft } from "@/components/Application/WrapperHeadingLeft";
import { WrapperHeadingRight } from "@/components/Application/WrapperHeadingRight";
import { WrapperLeft } from "@/components/Application/WrapperLeft";
import { WrapperRight } from "@/components/Application/WrapperRight";
import { AccordionDesign } from "@/components/Procedures/AccordionDesign";
import { ActiveProcedureDesign } from "@/components/Procedures/ActiveProcedureDesign";

import { useFetchActiveProcedureGroupFolders } from "@/service/ProcedureQueries";

export const Procedures: FC = () => {
	const { groupList, setGroupList } = useFetchActiveProcedureGroupFolders();
	const { expandAll, setExpandAll } = useContext(ProcedureContext);

	const handleToggleAll = useCallback(() => {
		setExpandAll((prev) => !prev);
	}, [setExpandAll]);

	return (
		<Grid container>
			<Grid item xs={12} sm={6}>
				<WrapperLeft className="wrapper--small">
					<div style={{ display: "flex" }}>
						<BreadCrumbsDesign />
					</div>

					<WrapperHeadingLeft
						handleToggleAll={handleToggleAll}
						expandAll={expandAll}
					/>
					<AccordionDesign
						groupList={groupList}
						SetGroupList={setGroupList}
						expandAll={expandAll}
					/>
				</WrapperLeft>
			</Grid>
			<Grid item xs={12} sm={6}>
				<WrapperRight className="wrapper--half">
					<WrapperHeadingRight />
					<ActiveProcedureDesign />
				</WrapperRight>
			</Grid>
		</Grid>
	);
};
